export const tryGetPathname = (urlString: string, baseUrl?: string): string | undefined => {
  if (!urlString) {
    return undefined;
  }

  if (urlString.startsWith("/")) {
    return urlString.split("?")[0]?.split("#")[0];
  }

  try {
    const parsedUrl = new URL(urlString);
    if (parsedUrl.protocol === "http:" || parsedUrl.protocol === "https:") {
      return parsedUrl.pathname;
    }
  } catch (error) {
    // Ignore
  }

  try {
    if (!baseUrl) {
      return undefined;
    }

    const parsedBaseUrl = new URL(baseUrl);
    if (parsedBaseUrl.protocol !== "http:" && parsedBaseUrl.protocol !== "https:") {
      return undefined;
    }

    const normalizedBaseUrl = `${parsedBaseUrl.origin}${parsedBaseUrl.pathname.replace(/\/?$/, "/")}`;
    return new URL(urlString, normalizedBaseUrl).pathname;
  } catch (error) {
    // Ignore
  }

  return undefined;
};
